import { CheckCircle, Download, Mail, Calendar, Phone, ArrowBigLeft, } from 'lucide-react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { downloadInvoice, getPaymentDetails, LoginLoader } from '../../Redux/Action/LoginAction';
import moment from 'moment';
import Loader from './Loader';

const ThankYouPage = () => {

    const location = useLocation();
    const dispatch = useDispatch()
    const router = useNavigate()
    const orderData = useSelector((state) => state.Auth.paymentDetail?.data)

    const searchParams = new URLSearchParams(location.search);
    const e_id = searchParams.get("e_id");
    useEffect(() => {
        dispatch(getPaymentDetails(e_id))
    }, [location.search]);
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [])

    const dateFormat = (date) => {
      const formatted = moment(date).format("DD-MM-YYYY hh:mm A");
        return formatted
    }

    const loader = useSelector((state) => state?.Auth?.loader);
    const handleDownloadInvoice = () => {
        dispatch(downloadInvoice(e_id))
        dispatch(LoginLoader())
    }
    return (
        <>
             {loader && (
                <div>
                  <div className="bg-black fixed  top-0 left-0 right-0 w-full h-full z-50 bg-opacity-50">
                    <div className="z-[50] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                      <Loader />
                    </div>
                  </div>
                </div>
              )}
        <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 py-12">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Success Header */}
                <div className="text-center mb-12">
                    <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
                        <CheckCircle className="w-12 h-12 text-green-600" />
                    </div>
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Payment Successful!</h1>
                    <p className="text-xl text-gray-600">Thank you for booking your consultation with Welcome Cure</p>
                </div>

                {/* Payment Details Card */}
                <div className="bg-white rounded-3xl shadow-xl p-8 mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Payment Details</h2>

                    <div className="grid md:grid-cols-2 gap-6 mb-8">
                        <div className="space-y-4">
                            <div className="flex justify-between items-center p-4 bg-gray-50 rounded-xl">
                                <span className="font-semibold text-gray-700">Order ID:</span>
                                <span className="font-mono text-blue-600">{orderData?.orderId}</span>
                            </div>

                            <div className="flex justify-between items-center p-4 bg-gray-50 rounded-xl">
                                <span className="font-semibold text-gray-700">Payment ID:</span>
                                <span className="font-mono text-blue-600">{orderData?.paymentID}</span>
                            </div>
                        </div>

                        <div className="space-y-4">
                            <div className="flex justify-between items-center p-4 bg-gray-50 rounded-xl">
                                <span className="font-semibold text-gray-700">Amount Paid:</span>
                                <span className="font-bold text-green-600 text-xl">₹ {Number(orderData?.amount) / Number(100)}</span>
                            </div>

                            <div className="flex justify-between items-center p-4 bg-gray-50 rounded-xl">
                                <span className="font-semibold text-gray-700">Date & Time:</span>
                                <span className="text-gray-900">{dateFormat(orderData?.date)}</span>
                            </div>
                        </div>
                    </div>

                    {/* Important Notice */}
                    <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-r-xl mb-8">
                        <div className="flex items-start">
                            <Mail className="w-6 h-6 text-blue-400 mt-1 mr-3" />
                            <div>
                                <h3 className="font-semibold text-blue-900 mb-2">Important Notice</h3>
                                <p className="text-blue-800">
                                    Please check your email  for login details.
                                    You can also download your invoice from the email or using the button below.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Download Invoice Button */}
                    <div className="text-center md:space-x-3 mb-8">
                        <button
                            // onClick={handleDownloadInvoice}
                            className="inline-flex items-center bg-[#FCDD00] hover:bg-yellow-400 text-black font-semibold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg"
                        >
                            <Download className="w-5 h-5 mr-2" />
                            Download Invoice
                        </button>
                        <button
                            onClick={() => router('/vfs_uk')}
                            className="inline-flex mt-4 items-center bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg"
                        >
                            <ArrowBigLeft className="w-5 h-5 mr-2" />
                           Back to Home
                        </button>
                    </div>
                </div>

                {/* Next Steps */}
                <div className="bg-white rounded-3xl shadow-xl p-8 mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">What's Next?</h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        <div className="text-center p-6 bg-blue-50 rounded-2xl">
                            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Mail className="w-8 h-8 text-blue-600" />
                            </div>
                            <h3 className="font-semibold text-gray-900 mb-2">Check Your Email</h3>
                            <p className="text-gray-600 text-sm">Login credentials have been sent to your email.</p>
                        </div>

                        <div className="text-center p-6 bg-green-50 rounded-2xl">
                            <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Calendar className="w-8 h-8 text-green-600" />
                            </div>
                            <h3 className="font-semibold text-gray-900 mb-2">Schedule Consultation</h3>
                            <p className="text-gray-600 text-sm">Use your login details to schedule your consultation at your convenience.</p>
                        </div>

                        <div className="text-center p-6 bg-purple-50 rounded-2xl">
                            <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Phone className="w-8 h-8 text-purple-600" />
                            </div>
                            <h3 className="font-semibold text-gray-900 mb-2">Get Expert Care</h3>
                            <p className="text-gray-600 text-sm">Connect with qualified doctors for professional medical consultation.</p>
                        </div>
                    </div>
                </div>

                {/* Support Information */}
                <div className="bg-gray-900 text-white rounded-3xl p-8 text-center">
                    <h2 className="text-2xl font-bold mb-4">Need Help?</h2>
                    <p className="text-gray-300 mb-6">
                        If you have any questions or need assistance, our support team is here to help.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <a
                            href="tel:9833593336"
                            className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full font-semibold transition-colors"
                        >
                            <Phone className="w-5 h-5 mr-2" />
                            Call Support: 98335 93336
                        </a>

                        <a
                            href="mailto:derick@welcomecure.com"
                            className="inline-flex items-center bg-[#FCDD00] hover:bg-yellow-400 text-black px-6 py-3 rounded-full font-semibold transition-colors"
                        >
                            <Mail className="w-5 h-5 mr-2" />
                            Email Support
                        </a>
                    </div>

                    <p className="text-gray-400 text-sm mt-4">
                        Support Hours: Mon - Saturday, 11am - 5pm
                    </p>
                </div>

            </div>
        </div>
        </>
    );
};

export default ThankYouPage;